export default __webpack_public_path__ + "static/tablet_KV03-73abb0b20c19a2bf0a2cd0e666589a95.mp4";